import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电视剧分类", to: "/category" },
  { label: "资讯专题", to: "/news" },
  { label: "关于本站", to: "/about" },
];

const friendLinks = [
  { label: "仙剑正传系列", to: "/category?cat=%E6%AD%A3%E4%BC%A0" },
  { label: "周边作品", to: "/category?cat=%E8%A1%8D%E7%94%9F" },
  { label: "相关仙侠剧", to: "/category?cat=%E7%9B%B8%E5%85%B3%E4%BB%99%E4%BE%A0" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-20">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-lg bg-primary-800 text-accent-300 flex items-center justify-center text-xl">
                <i className="ri-sparkling-2-fill"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-semibold text-background-50">
                  仙剑奇侠传
                </span>
                <span className="text-[11px] tracking-[0.3em] text-accent-400 mt-1">
                  仙侠影视站
                </span>
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-300 max-w-md">
              一个专注于仙剑奇侠传及经典仙侠影视作品的门户站点，聚合剧集详情、剧情介绍、角色分析与最新资讯，
              陪伴每一位仙侠爱好者重温心中的江湖。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">站内导航</h4>
            <ul className="flex flex-col gap-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 hover:text-accent-300 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">友情链接</h4>
            <ul className="flex flex-col gap-3">
              {friendLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 hover:text-accent-300 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 仙剑奇侠传影视站 · 本站为影视资讯与剧情展示的演示站点
          </p>
          <p className="text-xs text-background-400">
            所有剧集信息与图片均为演示内容，版权归原权利方所有
          </p>
        </div>
      </div>
    </footer>
  );
}